module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (77).f38b639b.jpg";